var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00af7d",
    d: "M4.535 3.628L8.163 0l.907.907-3.628 3.628L9.07 8.163l-.907.907-3.628-3.628L.907 9.07 0 8.163l3.628-3.628L0 .907.907 0l3.628 3.628z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMTAiCiAgaGVpZ2h0PSIxMCIKICB2aWV3Qm94PSIwIDAgMTAgMTAiCj4KICA8cGF0aAogICAgZmlsbD0iIzAwYWY3ZCIKICAgIGZpbGxSdWxlPSJldmVub2RkIgogICAgZD0iTTQuNTM1IDMuNjI4TDguMTYzIDBsLjkwNy45MDctMy42MjggMy42MjhMOS4wNyA4LjE2M2wtLjkwNy45MDctMy42MjgtMy42MjhMLjkwNyA5LjA3IDAgOC4xNjNsMy42MjgtMy42MjhMMCAuOTA3LjkwNyAwbDMuNjI4IDMuNjI4eiIKICA+PC9wYXRoPgo8L3N2Zz4=";
export { SvgClose as ReactComponent };